import {create} from 'zustand'

interface InlineDisclaimerData {
  __typename: string
  key: string
  textClick?: string
}
interface InlineDisclaimerState {
  inlineDisclaimers: InlineDisclaimerData[]
  setInlineDisclaimers: (inlineDisclaimers: InlineDisclaimerData[]) => void
  findInlineDisclaimer: (identifier: string) => InlineDisclaimerData | undefined
}

export const useInlineDisclaimerStore = create<InlineDisclaimerState>()((set, get) => ({
  inlineDisclaimers: [],
  setInlineDisclaimers: (inlineDisclaimers) => set((state) => ({...state, inlineDisclaimers})),
  findInlineDisclaimer: (identifier) => get().inlineDisclaimers.find(({key}) => identifier === key),
}))